import { ColorMode, Text } from '@chakra-ui/react';

import { DEFAULT_WEEK_DAY, styles, WEEK_DAYS } from '../../../../lib';

import type { ICalendarPlusSettings } from '../../../../lib';
import { useMemo } from 'react';

interface IMonthHeaderProps {
	settings: ICalendarPlusSettings;
	colorMode: ColorMode;
}
export const MonthHeader: React.FunctionComponent<IMonthHeaderProps> = ({ settings, colorMode }) => {
	const { fontSize } = styles.views.month;
	const WeekDays = useMemo(() => {
		const startDay = settings?.startOfWeek ?? DEFAULT_WEEK_DAY;
		return [...WEEK_DAYS.slice(startDay), ...WEEK_DAYS.slice(0, startDay)];
	}, [settings?.startOfWeek]);
	return (
		<>
			{WeekDays.map((day, index) => (
				<Text
					borderBottom={'1px solid'}
					borderRight={WEEK_DAYS.length - 1 !== index ? '1px solid' : ''}
					borderColor={settings.styles[colorMode].calendarBordersColor}
					key={day.label}
					fontSize={fontSize}
					textAlign='center'
					w='full'
					height='full'
					p='0.5rem !important'
					mb='0px !important'
				>
					{day.label}
				</Text>
			))}
		</>
	);
};
